(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["touni-wc-countdown"] && !Shopify.designMode) return;
  try {
    
(function(){
  var THREE_DAYS=3*24*60*60*1000;
  function init(el){
    var endStr=el.getAttribute('data-cd-end');
    var end=new Date(endStr.replace(' ','T'));
    if(isNaN(end)){return;}
    while(end<=new Date()){end=new Date(end.getTime()+THREE_DAYS);}
    var dD=el.querySelector('[data-d]'),dH=el.querySelector('[data-h]'),dM=el.querySelector('[data-m]'),dS=el.querySelector('[data-s]');
    function p(n){return (n<10?'0':'')+n;}
    function tick(){
      var s=Math.floor((end-new Date())/1000);
      if(s<=0){end=new Date(end.getTime()+THREE_DAYS);s=Math.floor((end-new Date())/1000);}
      var d=Math.floor(s/86400);s-=d*86400;var h=Math.floor(s/3600);s-=h*3600;var m=Math.floor(s/60);var sec=s-m*60;
      dD.textContent=p(d);dH.textContent=p(h);dM.textContent=p(m);dS.textContent=p(sec);
    }
    tick();setInterval(tick,1000);
  }
  document.querySelectorAll('.touni-cd').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
